function OauthRoutes() {
    return <div>
        OauthRoutes
    </div>
}

export default OauthRoutes